/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /************************************************/
    /* Section View Model                           */
    /************************************************/
    function ApplicationSectionModel(options) {

        var defaults = {
            AppearanceOrder: 0,
            SectionName: '',
            SectionTitle: '',
            SectionNavTitle: '',
            Applied: false,
            Required: false,
            Completed: false,
            SectionModel: null,
            SectionTemplate: null,
            Active: false
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.AppearanceOrder = ko.observable(settings.AppearanceOrder);
        this.SectionName = ko.observable(settings.SectionName);
        this.SectionTitle = ko.observable(settings.SectionTitle);
        this.SectionNavTitle = ko.observable(settings.SectionNavTitle);
        this.Applied = ko.observable(settings.Applied);
        this.Required = ko.observable(settings.Required);
        this.Active = ko.observable(settings.Active);
        this.SectionModel = ko.observable(settings.SectionModel);
        this.SectionTemplate = ko.observable(settings.SectionTemplate);

        // Computed
        this.Completed = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.SectionModel())) {
                return false;
            }
            if (smapi.constant.applicationDebugFlag) { console.log('Section Completed [' + this.SectionName() + ']: ' + this.SectionModel().Completed()); }
            return this.SectionModel().Completed();
        }, this);
        
        sm.portal.vm.custom.callCustomization('UpdateApplicationSectionProps', self);
        this.NavigationClass = ko.computed(function () {
            var classes = 'appsecItem';

            var acctModel = viewModel.GetSectionModel('Account');
            var beforeTermsModel = viewModel.GetSectionModel('BeforeTerms');
            var curModel = viewModel;

            if (this.Active()) {
                classes += ' active';
            }
            else if (!acctModel.AllowNext() && !acctModel.IsLoggedIn()) {
                classes += ' disabled';
            }
            else if ( beforeTermsModel && !beforeTermsModel.Completed() && this.SectionName() !== 'BeforeTerms') {
                classes += ' disabled';
            }
            var cusData = {
                self: self,
                classes: classes
            }

            sm.portal.vm.custom.callCustomization('UpdateNavigationClass', cusData);

            if(sm.portal.utility.isAPASFeatureEnabled() && this.SectionTitle() === sm.portal.utility.getResourceValue('DemographicInformation')){
                let required = Boolean(this.SectionModel().IsPermanentResident() || this.SectionModel().HaveStudyPermit() || this.SectionModel().HaveWorkPermit());
                this.Required(required);
            }

            classes += ' appsecReq' + this.Required() + 'Com' + this.Completed();

            return classes;
        }, self);

        this.AriaCurrent = ko.computed(function () {
            if (this.Active()) {
                var currentSection = this.SectionTitle;
                return currentSection;
            }
            else {
                return null;
            }
           
           }, self);

        this.SectionIndex = ko.computed(function () {

            var thisIndex = 0;
            for (var i = 0; i < viewModel.AppliedSections().length; i++) {
                if (viewModel.AppliedSections()[i].SectionName() == this.SectionName()) {
                    thisIndex = i + 1;
                }
            }

            return thisIndex.toString();
        }, self);
        this.FormName = ko.computed(function () {
            return sm.portal.utility.formatString('{0}Form', self.SectionName());
        }, this);
        this.AllowNext = ko.computed(function () {
            try {
                var AllowNextCustom = sm.portal.vm.custom.callCustomization('AllowNextCustom', self); 
                if(!sm.portal.utility.isNullOrEmpty(AllowNextCustom)){
                    return AllowNextCustom;
                }
                return this.SectionModel().AllowNext();
            } catch (e) {
                return true; // If it's not overwritten, assume it's ok to continue.
            }
        }, this);

        // Methods
        this.SectionNavClicked = function () {

            var loadSection = true;
            if (this.SectionName() == 'Summary' && !viewModel.SubmitAvailable()) {
                loadSection = false;
            }

            var retcus = sm.portal.vm.custom.callCustomization("CustomDisableNavigtion",self);
            if(!sm.portal.utility.isNullOrEmpty(retcus)){
                var beforeTermsAccepted = sm.portal.utility.isNullOrEmpty(sm.portal.page.application.beforeTermsAccepted) ? false : sm.portal.page.application.beforeTermsAccepted;
                if(!beforeTermsAccepted && (this.SectionName()!=="Account" && this.SectionName()!=="BeforeTerms")){
                    return;
                }
            }

            var params = {
                self: self,
                loadSection: loadSection,
                viewModel: viewModel
            }

            sm.portal.vm.custom.callCustomization('UpdateSectionNavClicked', params);

            if (loadSection) {
                this.Active(true);
                viewModel.ActiveSectionChanged(self);
                if(this.SectionName() == 'HighSchool' && sm.portal.utility.isAPASFeatureEnabled()){
                    this.SectionModel().Completed(true);
                }
            }
        };
        this.SectionNavSidebarClicked = function () {

            // Are we in Sidebar or Sidebar Collapsed mode?
            
            //Business rule: must be logged in or have passwords to navigate off account section.
            var acctModel = viewModel.GetSectionModel('Account');
            // - check if logged in.
            if (!acctModel.IsLoggedIn())
            {
                var regularExpressionString = acctModel.PasswordRegex();
                var regularExpression = new RegExp(regularExpressionString);
                var minNumberofChars = acctModel.PasswordMinLength();;

                // - if not logged in, check if passwords are available
                var newPassword = jQuery("#NewAccountPassword").val();
                var newPasswordConfirm = jQuery("#NewAccountConfirmPassword").val();

                //if passwords are not in the dom find them in the view model.
                if (sm.portal.utility.isNullOrEmpty(newPassword)) {
                    newPassword = acctModel.NewAccountPassword();
                }
                if (sm.portal.utility.isNullOrEmpty(newPasswordConfirm)) {
                    newPasswordConfirm = acctModel.NewAccountConfirmPassword();
                }

                // Are the password account fields filled in?
                if (sm.portal.utility.isNullOrEmpty(newPassword) || sm.portal.utility.isNullOrEmpty(newPasswordConfirm)) {
                    return; // don't navigate away
                }
                else if (!sm.portal.utility.isNullOrEmpty(newPassword) && !sm.portal.utility.isNullOrEmpty(newPasswordConfirm)) {
                    if (newPassword.length < minNumberofChars) {
                        return; // don't navigate away
                    }
                    if (!regularExpression.test(newPassword)) {
                        return; // don't navigate away
                    }
                    if (newPassword != newPasswordConfirm) {
                        return; // don't navigate away
                    }
                }
            }

            if (sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization("CanAdvanceAfterTermsHide")) && !viewModel.CanAdvanceAfterTerms(viewModel.CurrentSection())) {
                return;
            }

            var allOtherLi = jQuery(".applicationSidebar li").not(this);
            var li = jQuery(".applicationSidebar li[datasectionname='" + this.SectionName() + "']");
            var titleBar = jQuery(li).find('span.appsecTitle');
            var displayTitle = titleBar.css('display');

            if (smapi.constant.applicationDebugFlag) {
                console.log('Display Title: ' + displayTitle);
                console.log('Has Expanded Class: ' + li.hasClass('expanded'));
            }

            if (displayTitle == 'none') {

                allOtherLi.removeClass('expanded');
                allOtherLi.find('span.appsecTitle').removeClass('expanded');
                // In Compacted View, needs to expand
                li.addClass('expanded');
                titleBar.addClass('expanded');

            } else {
                if (li.hasClass('expanded')) {
                    // In Compacted View, but already expanded
                    li.removeClass('expanded');
                    titleBar.removeClass('expanded');
                }

                // Close any Expanded on other LIs when navigating away
                var allLIs = jQuery(".applicationSidebar li").each(function () {
                    jQuery(this).removeClass('expanded')
                    var titleBar = jQuery(this).find('span.appsecTitle').removeClass('expanded');
                });

                // Navigate
                var customData = {
                    self: self,
                    li: li
                }
                var retParams = sm.portal.vm.custom.callCustomization('CustomListItem',customData);
                if(sm.portal.utility.isNullOrEmpty(retParams)){
                    this.SectionNavClicked();
                }

            }
        };
        this.Activate = function () {

            if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Activating ' + this.SectionName()); }
            if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Data Loaded? ' + this.SectionModel().DataLoaded()); }
            if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Data Loading? ' + this.SectionModel().DataLoading()); }

            // If Data Is not loaded, block UI and load data
            if (!this.SectionModel().DataLoaded() && !this.SectionModel().DataLoading()) {
                this.SectionModel().GetModelData(true, viewModel.ApplicationMID(), viewModel.PersonMID());
            } else if (!this.SectionModel().DataLoaded() && this.SectionModel().DataLoading()) {
                self.SectionModel().BlockContainer();
            } else if (this.SectionModel().DataLoaded() && !this.SectionModel().DataLoading()) {
                self.SectionModel().UnBlockContainer();
            }

            // Attempt to initialize the model, some may not have this method
            try {
                this.SectionModel().Initialize(this);
            } catch (e) { if (smapi.constant.applicationDebugFlag) { console.log('No Initialize on this model: ' + e.message); } }

            // Attempt to trigger any child properties for IsRequired
            try {
                this.SectionModel().IsRequired(self.Required());
            } catch (e) { }

            // Set the Active Flag
            this.Active(true);
            // Set the Touched Flag
            this.SectionModel().Touched(true);

            // Ready Page
            sm.portal.ui.readyPage();
            sm.portal.page.application.revealAppContent();
            sm.portal.page.application.fieldHelp();

            // GENERIC PROTYTPE SCRIPTS 
            sm.portal.page.application.addDetailedListItem();
            sm.portal.page.application.additionalFieldsToggle();
        };
        // Method to update section configurations from admin portal
        this.SetSectionsConfigData = function(configData, isDynamicSection){
            // If ConfigData has keys, update it
            if(!sm.portal.utility.isNullEmptyOrNothing(configData)) {
                // section show/hide
                if(!sm.portal.utility.isNullOrEmpty(configData.ShowSection) && !isDynamicSection){
                    this.Applied(configData.ShowSection);
                    !configData.ShowSection && this.Required(false);  // If it's not applied, it's not required
                }
                //section name change
                if (configData.SectionName) {
                    this.SectionNavTitle(configData.SectionName);
                    this.SectionTitle(configData.SectionName);
                }
                // Appearance order
                if (configData.AppearanceOrder) {
                    this.AppearanceOrder(configData.AppearanceOrder);
                }
            }
        };
        
        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        ApplicationSectionModel: ApplicationSectionModel,
    });

})(jQuery);